"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputSliderDropdown = void 0;
var react_1 = __importStar(require("react"));
var antd_1 = require("antd");
var FromTo_1 = require("../FromTo");
var transifex_1 = require("../../transifex");
var InputSliderDropdown = function (_a) {
    var children = _a.children, value = _a.value, addonPre = _a.addonPre, addonSuffix = _a.addonSuffix, range = _a.range, onChange = _a.onChange, fromToInputProps = _a.fromToInputProps, _b = _a.min, min = _b === void 0 ? 0 : _b, _c = _a.max, max = _c === void 0 ? 100 : _c, rest = __rest(_a, ["children", "value", "addonPre", "addonSuffix", "range", "onChange", "fromToInputProps", "min", "max"]);
    var _d = react_1.useState(false), visisble = _d[0], setVisible = _d[1];
    var _e = react_1.useState(range ? [min, max] : min), internalValue = _e[0], setInternalValue = _e[1];
    var updateInternalStateWithProp = react_1.useCallback(function (v) {
        if (v) {
            setInternalValue(v);
        }
        else {
            setInternalValue(range ? [min, max] : min);
        }
    }, [max, min, range]);
    var onCancel = react_1.useCallback(function () {
        updateInternalStateWithProp(value);
        setVisible(false);
    }, [updateInternalStateWithProp, value]);
    var onReset = react_1.useCallback(function () {
        updateInternalStateWithProp(value);
    }, [updateInternalStateWithProp, value]);
    var onApply = react_1.useCallback(function () {
        onChange === null || onChange === void 0 ? void 0 : onChange(internalValue);
        setVisible(false);
    }, [internalValue, onChange]);
    react_1.useEffect(function () {
        updateInternalStateWithProp(value);
    }, [updateInternalStateWithProp, value]);
    var sliderProps = __assign(__assign({}, rest), { value: internalValue, range: range,
        min: min,
        max: max });
    var overlay = (react_1.default.createElement("div", { style: {
            background: "white",
            padding: "1rem",
            display: "flex",
            flexDirection: "column",
            rowGap: 16,
        } },
        react_1.default.createElement(antd_1.Row, { gutter: 8, style: { width: "100%" }, wrap: false, align: "middle" },
            react_1.default.createElement(antd_1.Col, { flex: "none" }, addonPre === null || addonPre === void 0 ? void 0 : addonPre(internalValue)),
            react_1.default.createElement(antd_1.Col, { flex: "auto" },
                react_1.default.createElement(antd_1.Slider, __assign({}, sliderProps, { onChange: function (v) {
                        setInternalValue(v);
                    }, value: internalValue }))),
            react_1.default.createElement(antd_1.Col, { flex: "none" }, addonSuffix === null || addonSuffix === void 0 ? void 0 : addonSuffix(internalValue))),
        range && (react_1.default.createElement(FromTo_1.FromTo, { from: react_1.default.createElement(antd_1.InputNumber, __assign({}, fromToInputProps, { onChange: function (v) {
                    if (Number.isFinite(v))
                        setInternalValue(function (p) { return [v, p[1]]; });
                }, value: internalValue === null || internalValue === void 0 ? void 0 : internalValue[0], min: min, max: internalValue === null || internalValue === void 0 ? void 0 : internalValue[1] })), to: react_1.default.createElement(antd_1.InputNumber, __assign({}, fromToInputProps, { value: internalValue === null || internalValue === void 0 ? void 0 : internalValue[1], onChange: function (v) {
                    if (Number.isFinite(v))
                        setInternalValue(function (p) { return [p[0], v]; });
                }, min: internalValue === null || internalValue === void 0 ? void 0 : internalValue[0], max: max })) })),
        react_1.default.createElement(antd_1.Divider, { style: { margin: 0 } }),
        react_1.default.createElement(antd_1.Space, { style: { width: "100%", justifyContent: "space-between" } },
            react_1.default.createElement(antd_1.Button, { onClick: onReset, type: "text" }, transifex_1.TX_RESET),
            react_1.default.createElement(antd_1.Space, null,
                react_1.default.createElement(antd_1.Button, { onClick: onCancel }, transifex_1.TX_CANCEL),
                react_1.default.createElement(antd_1.Button, { type: "primary", onClick: onApply }, transifex_1.TX_APPLY)))));
    return (react_1.default.createElement(antd_1.Dropdown, { visible: visisble, trigger: ["click"], overlay: react_1.default.createElement(antd_1.Menu, null, overlay) }, children === null || children === void 0 ? void 0 : children(internalValue, function () { return setVisible(true); })));
};
exports.InputSliderDropdown = InputSliderDropdown;
